module.exports = __webpack_public_path__ + "img/logo-email.c6d3b854.jpg";